import React, { forwardRef } from 'react';

const IcStatusAllow = forwardRef(
  (properties, ref) => /* @__PURE__ */ React.createElement(
    "svg",
    {
      fill: "none",
      height: "16",
      viewBox: "0 0 16 16",
      width: "16",
      xmlns: "http://www.w3.org/2000/svg",
      ...properties,
      ref
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M13 4L6.5 10.5L3 7",
        stroke: "var(--positive-icon-strong-default)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2"
      }
    )
  )
);

export { IcStatusAllow };
//# sourceMappingURL=ic-status-allow.js.map
